import { SliceComponentProps } from '@prismicio/react';
import { asText, Content, isFilled } from '@prismicio/client';
import { faFile, IconDefinition } from '@fortawesome/pro-regular-svg-icons';

import { Box, Heading, Icon, Link } from '@preventx/oxygen';

// Types
import { FileType } from '@/types/file';

// Services
import { retrieveIcon } from '@/services/utils/icons';

export type FileAttachmentProps =
  SliceComponentProps<Content.FileAttachmentSlice>;

const FileAttachment = ({ slice }: FileAttachmentProps) => {
  const { primary } = slice;

  return (
    <Box component="div" addFlow>
      {primary.title && (
        <Heading component="h3">{asText(primary.title)}</Heading>
      )}

      {(primary.files ?? []).map(({ file }) => {
        if (!isFilled.link(file)) {
          return null;
        }

        const { id, name } = file;

        if (!name) {
          return null;
        }

        let icon: IconDefinition = faFile;

        const fileExtension = name.split('.').pop()?.toUpperCase() as FileType;

        if (fileExtension) {
          icon = retrieveIcon(fileExtension);
        }

        return (
          <Box addCluster component="div" key={`file-attachment-${id}`}>
            <Icon icon={icon} />
            <Link
              download
              type="link"
              as="default"
              target="_blank"
              href={file.url}
            >
              {file.text}
            </Link>
          </Box>
        );
      })}
    </Box>
  );
};

export default FileAttachment;
